// Module
var code = "<div class=\"code-demo-toolbar\">\n  <div class=\"code-demo-toolbar-left\">\n    <slot name=\"left\"></slot>\n  </div>\n  <div class=\"code-demo-toolbar-right\">\n    <slot name=\"right\"></slot>\n  </div>\n</div>\n";
// Exports
export default code;